/**

Coded by www.techhighway.ca

*/

// react-router-dom components
import { Link } from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @mui material components
import { Breadcrumbs as MuiBreadcrumbs } from "@mui/material";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

function Breadcrumbs({ icon, title, route, light=false }) {
  const routes = route.slice(0, -1);

  return (
    <MDBox mr={{ xs: 0, xl: 0 }} sx={{ float: "right" }}>
      <MuiBreadcrumbs
        sx={{
          "& .MuiBreadcrumbs-separator": {
            color: ({ palette: { white, grey } }) => (light ? "rgba(46, 44, 44, 0.85)" : grey[600]),
          },
        }}
      >
        <Link to="/">
          <MDTypography component="span" variant="body2" sx={{ lineHeight: 0 }}>
            <Icon>{icon}</Icon>
          </MDTypography>
        </Link>
        {routes.map((el) => (
          <Link to={`/${el}`} key={el}>
            <MDTypography
              component="span"
              variant="button"
              fontWeight="regular"
              textTransform="capitalize"
              sx={{
                lineHeight: 0,
                "&.MuiTypography-button": {
                  fontSize: "0.75rem",
                },
              }}
            >
              {el
                .replaceAll("grn", "GRN")
                .replaceAll("hsn-codes", "HSN Codes")
                .replaceAll("manage-", "")
                .replaceAll("-", " ")}
            </MDTypography>
          </Link>
        ))}
        {title ? (
          <MDTypography
            variant="button"
            fontWeight="regular"
            sx={{
              lineHeight: 0,
              "&.MuiTypography-button": {
                fontSize: "0.75rem",
              },
            }}
          >
            {title.replaceAll("-", " ")}
          </MDTypography>
        ) : (
          <MDTypography
            variant="button"
            fontWeight="regular"
            textTransform="capitalize"
            sx={{
              lineHeight: 0,
              "&.MuiTypography-button": {
                fontSize: "0.75rem",
              },
            }}
          >
            {route[route.length - 1]
              .replaceAll("grn", "GRN")
              .replaceAll("hsn-codes", "HSN Codes")
              .replaceAll("manage-", "")
              .replaceAll("-", " ")}
          </MDTypography>
        )}
      </MuiBreadcrumbs>
    </MDBox>
  );
}

// // Setting default values for the props of Breadcrumbs
// Breadcrumbs.defaultProps = {
//   light: false,
// };

// Typechecking props for the Breadcrumbs
Breadcrumbs.propTypes = {
  icon: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  route: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
  light: PropTypes.bool,
};

export default Breadcrumbs;
